var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendSolidBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 54,
    viewBox: "0 0 59 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.149132 4.38492L6.15478 23.9567H59L4.74529 0.283726C3.02944 -0.464951 1.03155 0.319096 0.282869 2.03495C-0.0409767 2.77715 -0.0884179 3.61077 0.149132 4.38492ZM59 30.0485L4.74549 53.7062C4.00327 54.0298 3.16972 54.0771 2.39567 53.8394C0.606058 53.2899 -0.39925 51.3937 0.15025 49.6041L6.15478 30.0485H59ZM37.2866 33.8969H10.8639L6.77937 47.4556L37.2866 33.8969ZM6.77937 6.77937L37.2866 20.3381H10.8639L6.77937 6.77937Z",
    fill: "#0082FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendSolidBlue);
export default __webpack_public_path__ + "static/media/send-solid-blue.d6c4c2aaaa27aee54824fcd6844e6f07.svg";
export { ForwardRef as ReactComponent };